import { Box, Text, chakra } from '@chakra-ui/react';
import { NavArrowRight } from 'iconoir-react';
import { EmailGlyphAvatar } from './EmailGlyphAvatar';

interface RecipientEmailRowProps {
  email: string;
  actionLabel?: string;
  onSelect: (email: string) => void;
}

/**
 * The "use this typed email" affordance. Shown when the search term is a valid
 * email that matches no known contact, so the brand can reach someone it knows
 * out-of-band. Selecting it emits a raw-email recipient. Unlike the contact
 * result rows (flat list options), this one usually stands ALONE under the
 * input, so it reads as a bordered action card with a trailing arrow.
 */
export const RecipientEmailRow = ({ email, actionLabel, onSelect }: RecipientEmailRowProps) => (
  <chakra.button
    type="button"
    display="flex"
    alignItems="center"
    gap="10px"
    px="10px"
    py="8px"
    rounded="10px"
    textAlign="left"
    w="full"
    cursor="pointer"
    borderWidth="1px"
    borderColor="cardBorder"
    bg="panelBg"
    transition="background 0.15s, border-color 0.15s"
    _hover={{ bg: 'background', borderColor: 'primary.300' }}
    onClick={() => onSelect(email)}
  >
    <EmailGlyphAvatar />
    <Box minW={0} flex="1">
      <Text fontSize="sm" fontWeight="medium" lineClamp={1}>
        {email}
      </Text>
      {actionLabel && (
        <Text fontSize="xs" color="primary.600" fontWeight="medium" lineClamp={1}>
          {actionLabel}
        </Text>
      )}
    </Box>
    {/* Chevron, not a full arrow: the codebase idiom for a row that advances
        (contact nav rows, program rows); arrows stay on CTAs. */}
    <Box color="fg.muted" flexShrink={0} display="inline-flex">
      <NavArrowRight width={16} height={16} />
    </Box>
  </chakra.button>
);
